var __rspack_ns_object = {"rE":"7.10.6"}